<template>
  <el-dialog
    title="线下代缴"
    :visible.sync="visible"
    width="520px"
    custom-class="lease-ylw-dialog"
    :close-on-click-modal="false"
    append-to-body
  >
    <el-form ref="form" :model="form" :rules="rules" label-width="100px" size="small">
      <el-form-item label="支付金额" prop="payAmount">
        <el-input
          v-model="form.payAmount"
          clearable
          maxlength="10"
          placeholder="请输入支付金额"
        />
      </el-form-item>
      <el-form-item label="支付凭证" prop="voucherUrl">
        <lease-image-upload
          v-model="form.voucherUrl"
          :limit="5"
          :max-size-mb="3"
          tip="图片格式 jpg、jpeg、png，最多 5 张，每张大小不超过 3M"
        />
      </el-form-item>
    </el-form>
    <span slot="footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button type="primary" :loading="loading" @click="submit">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import moment from "moment";
import LeaseImageUpload from "./LeaseImageUpload.vue";
import { PayMethod } from "@/service/fishPondLeaseEnums";
import { offlinePayContract, addRent, leaseRequestError } from "@/service/fishPondLease";

export default {
  name: "OfflinePayDialog",
  components: { LeaseImageUpload },
  data() {
    return {
      visible: false,
      loading: false,
      contractId: null,
      useRentApi: false,
      form: this.emptyForm(),
      rules: {
        payAmount: [{ required: true, message: "请输入支付金额", trigger: "blur" }]
      }
    };
  },
  methods: {
    emptyForm() {
      return {
        payAmount: "",
        voucherUrl: ""
      };
    },
    open(contractId, options = {}) {
      this.contractId = contractId;
      this.useRentApi = !!options.useRentApi;
      this.form = this.emptyForm();
      this.visible = true;
      this.$nextTick(() => this.$refs.form && this.$refs.form.clearValidate());
    },
    submit() {
      this.$refs.form.validate(async valid => {
        if (!valid) return;
        var amount = Number(this.form.payAmount);
        if (!(amount > 0)) {
          this.$message.warning("请输入支付金额");
          return;
        }
        this.loading = true;
        const payload = {
          contractId: this.contractId,
          payAmount: amount,
          payDate: moment().format("YYYY-MM-DDTHH:mm:ss"),
          voucherUrl: this.form.voucherUrl,
          payMethod: PayMethod.Offline
        };
        try {
          if (this.useRentApi) {
            await addRent(payload);
          } else {
            await offlinePayContract(payload);
          }
          this.$message.success("操作成功");
          this.visible = false;
          this.$emit("success");
        } catch (e) {
          this.$message.error(leaseRequestError(e));
        } finally {
          this.loading = false;
        }
      });
    }
  }
};
</script>
